/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FormattedMessage } from 'react-intl';

/** @deprecated use `intl.formatMessage` instead */
const translate = (id, value = {}) => (
  <FormattedMessage id={id} values={{ ...value }} />
);

export default translate;
